












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Icon, Select } from '@alpha/ink'
import A from '@/utilities/alpha'

export interface SelectOption {
  label: string,
  id: string | number
}

@Component({
  components: { Select, Icon }
})
export default class EditMetaDataModal extends Vue {
  @Prop({ required: true }) selectableOptions!: SelectOption[]
  @Prop({ required: true }) alreadySelectedOptions!: SelectOption[]
  @Prop({ required: true }) headerText!: string
  @Prop({ default: 'Already selected' }) alreadySelectedHeaderText!: string
  @Prop({ default: 'None selected' }) noneSelectedText!: string

  get sortedSelectableOptions () {
    const plainTextLabelOptions: SelectOption[] = this.selectableOptions.map(option => {
      const label = option.label.replace('\n', '')
      option.label = A.stripHTML(label)
      return option
    })
    return plainTextLabelOptions.sort((optionA: SelectOption, optionB: SelectOption) => optionA.label.toUpperCase() > optionB.label.toUpperCase() ? 1 : -1)
  }

  hovering: boolean | number = false

  selectOption (option: SelectOption) {
    this.$emit('selectOption', option.id)
  }

  unSelectOption (option: SelectOption) {
    this.$emit('unSelectOption', option.id)
  }
}

